import type { Email } from '../../entities/email/emailTypes';
import { MOCK_GROUP_ID } from './mockSite';

/**
 * Dataset mock per Email. Audit allineato a mockCalls (userId 1 =
 * "Jader Francia"). emailDate distribuite su 4 mesi per popolare la
 * timeline. Mix IN/OUT per testare i filtri.
 *
 * Le Relationship Email <-> Person/Business sono in relationshipMocks.ts.
 */
const baseAudit = { companyId: 1, groupId: MOCK_GROUP_ID, userId: 1, userName: 'Jader Francia' };
const auditAt = (iso: string) => ({ ...baseAudit, createDate: iso, modifiedDate: iso });

export const mockEmails: Email[] = [
  // --- Aprile 2026 ---
  {
    emailId: 1,
    direction: 'OUT',
    emailDate: '2026-04-12T08:45:00Z',
    description: 'Invio offerta commerciale a Fornari Srl con preventivo aggiornato e tempistiche di consegna.',
    ...auditAt('2026-04-12T08:45:00Z'),
  },
  {
    emailId: 2,
    direction: 'IN',
    emailDate: '2026-04-08T11:30:00Z',
    description: 'Acme Corp - Michele Placido conferma ricezione documentazione tecnica, richiede integrazione su modulo sicurezza.',
    ...auditAt('2026-04-08T11:30:00Z'),
  },

  // --- Marzo 2026 ---
  {
    emailId: 3,
    direction: 'OUT',
    emailDate: '2026-03-25T16:20:00Z',
    description: 'Invio piano dettagliato a Giulia Ferri (Edilizia Moderna) come da accordo telefonico.',
    ...auditAt('2026-03-25T16:20:00Z'),
  },
  {
    emailId: 4,
    direction: 'IN',
    emailDate: '2026-03-15T09:00:00Z',
    description: 'Elena Marchetti (Giubra) inoltra richiesta di chiarimento su clausole contrattuali.',
    ...auditAt('2026-03-15T09:00:00Z'),
  },
  {
    emailId: 5,
    direction: 'OUT',
    emailDate: '2026-03-08T14:00:00Z',
    description: 'Promemoria a Roberto Bianchi (Miksi) per riscontro su preventivo inviato il mese scorso.',
    ...auditAt('2026-03-08T14:00:00Z'),
  },

  // --- Febbraio 2026 ---
  {
    emailId: 6,
    direction: 'OUT',
    emailDate: '2026-02-22T10:15:00Z',
    description: 'Trasmissione documentazione progetto pilota ad AlpiSolar (Thomas Huber) per il mercato austriaco.',
    ...auditAt('2026-02-22T10:15:00Z'),
  },
  {
    emailId: 7,
    direction: 'IN',
    emailDate: '2026-02-10T15:45:00Z',
    description: 'Marco Zanetti (Trentino Sicurezza) richiede slot di disponibilità per workshop on-site.',
    ...auditAt('2026-02-10T15:45:00Z'),
  },

  // --- Gennaio 2026 ---
  {
    emailId: 8,
    direction: 'OUT',
    emailDate: '2026-01-28T11:00:00Z',
    description: 'Newsletter di gennaio inviata ai contatti del segmento "PMI costruzioni".',
    ...auditAt('2026-01-28T11:00:00Z'),
  },
];
